import confetti from 'canvas-confetti';

interface CourseProgressProps {
    canMarkComplete: boolean;
    isUpdating: boolean;
    onMarkComplete: () => void;
}

export function CourseProgress({ 
    canMarkComplete, 
    isUpdating, 
    onMarkComplete
}: CourseProgressProps) {
    const handleMarkComplete = () => {
        // Show confetti for lesson completion
        confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 }
        });
        onMarkComplete();
    };

    return (
        <div className="bg-white p-6 border-t border-slate-200">
            <div className="flex justify-center">
                <button
                    onClick={handleMarkComplete}
                    disabled={!canMarkComplete || isUpdating}
                    className={`px-6 py-3 text-sm font-medium text-white rounded-lg flex items-center justify-center transition-colors shadow-sm ${
                        canMarkComplete && !isUpdating 
                            ? 'bg-green-600 hover:bg-green-700 shadow-green-200' 
                            : 'bg-green-300 cursor-not-allowed'
                    }`}
                >
                    {isUpdating ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                            Completing...
                        </>
                    ) : (
                        canMarkComplete ? 'Mark Complete' : 'Watch video to complete'
                    )}
                </button>
            </div>
        </div>
    );
}
